import { grid } from './grid'

const selectedCell = {
  ref: grid[0][0],
  column: 0,
  row:    0
}

export default selectedCell